import script from "./SharedCommentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedCommentForm.vue?vue&type=script&setup=true&lang=js"

import "./SharedCommentForm.vue?vue&type=style&index=0&id=baa7e1ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-baa7e1ce"]])

export default __exports__